import Auth from '../utils/authclass'

const serialisedata = Auth.getUserSession()

export const initialState = serialisedata?.token?.length>30 
? {isloggedin: true, profile: serialisedata }
: {isloggedin: false, profile: {}}

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGGEDIN':
      return {
        ...state,
        profile: action.profile,
        isloggedin: action.profile? true : false
      };
    default:
      return state;
  }
};

export default sessionReducer;
